import { css } from "@emotion/react"
import { Section } from "../../../../packages/editing/Section"
import { responsiveCss } from "../ui/helpers/css"
import { TrustpilotWidget } from "../ui/components/other/TrustpilotWidget"

function TrustpilotHorizontal(section: {}) {
    return (
        <>
            <div style={{ marginTop: 20, marginBottom: 20 }}>
                <div
                    style={{ scale: "0.9", transform: "translateY(2px)" }}
                    css={responsiveCss("max", "sm", { display: "none" })}
                >
                    <TrustpilotWidget widget="horizontal" />
                </div>
                <div
                    css={css(
                        { scale: "0.8", display: "flex", justifyContent: "center" },
                        responsiveCss("min", "sm", { scale: "0.9" }),
                        responsiveCss("min", "md", { display: "none" })
                    )}
                >
                    <TrustpilotWidget widget="microCombo" width={500} />
                </div>
            </div>
        </>
    )
}

Section("TrustpilotHorizontal", TrustpilotHorizontal)
